module.exports = __webpack_public_path__ + "img/matteo-ranghetti.20ff6834.jpg";